import * as React from 'react';
import * as styles from './Quote.css';
import { TRenderable } from '../SharedTypes';

export function Quote({ children }: { children: TRenderable }) {
	return <div className={styles.text}>{children}</div>;
}
